// extracted by css-extract-rspack-plugin
export default {"label":"XIPF0GCFQs068M6i"};